export const upSellsSelector = (state) => state.upSells;

export default upSellsSelector;
